{
  "appType": "standalone",
  "assetsUrl": "https://dev-dashboard.va-endpoint.com/",
  "standaloneBaseUrl": "https://dev-dashboard.va-endpoint.com",
  "translationsUrl": "https://dev-cdn.va-endpoint.com/translations/dashboard",
  "announcementModalApiUrl": "https://dev.twipla.com/api/v1/inapp/bubbles/index.php",
  "announcementBannerApiUrl": "https://dev.twipla.com/api/v1/inapp/banners/index.php",
  "dashboardTilesApiUrl": "https://www.twipla.com/api/v1/inapp/tiles/",
  "defaultVoucherCode": "THIS_IS_A_TEST_VOUCHER",
  "wixAppId": "7c82c6ed-2095-4654-843d-8c1c5dd4fd83",
  "wixBaseUrl": "https://dev-wix-dashboard.va-endpoint.com/",
  "apiUrl": "https://dev-api.va-endpoint.com/api",
  "aiApiUrl": "https://dev-ai.va-endpoint.com",
  "gatewayApiUrl": "https://api-gateway.va-endpoint.com",
  "dashboardWebsiteId": "929af995-e207-11ee-a93f-42e75f09418b",
  "presentationWebsiteId": "326865a9-6d58-11e8-834c-0242ac120005",
  "workerEnv": "dev",
  "paddleVendorId": 1315,
  "paddleSandbox": true,
  "wixIgnoreVisitsUrl": "https://dev-loadbalancer.va-endpoint.com/worker-messages",
  "reCaptchaSiteKey": "6Lez-tkUAAAAAEh8Pn3-ikUmU6p2svEXN-LCl2iY",
  "statsOverviewReleaseDate": 1577836800,
  "chatwootToken": "6PKafZ6wwTAdrR3FgDUzxnq3",
  "awlChatwootToken": "mFb3owCeazTeCmxQHg7ZR6Qf",
  "env": "prod",
  "surveysUrl": "https://dev-surveys-app.va-endpoint.com",
  "firstPromoter": {
    "apiUrl": null,
    "apiKey": null,
    "wId": null
  },
  "competitionReleaseDate": 1596319200,
  "supportedLanguages": [
    "en",
    "de",
    "es",
    "pt",
    "it",
    "fr",
    "ro"
  ],
  "customDomain": ".va-endpoint.com",
  "maintenancePeriods": [
    [
      "2024-10-31T03:30:00.000Z",
      "2024-10-31T10:30:00.000Z"
    ],
    [
      "2024-12-06T03:30:00.000Z",
      "2024-12-06T05:30:00.000Z"
    ],
    [
      "2024-11-06T03:30:00.000Z",
      "2024-11-06T05:30:00.000Z"
    ]
  ],
  "flagSmithEnvironmentId": "YFYfBhUaiGMLzKDLFSoAck",
  "sentryDsn": "https://38dc1a994a42cfb9f8e479ca26a80439@sentry.visitor-analytics.io/2",
  "sentryAuthToken": "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",
  "sourceTag": "develop-2462"
}
